export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_ESTABLISHMENT_SUCCESS = 'CREATE_ESTABLISHMENT_SUCCESS';
export const EDIT_ESTABLISHMENT_SUCCESS = 'EDIT_ESTABLISHMENT_SUCCESS';
export const CREATE_ESTABLISHMENT_FAILURE = 'CREATE_ESTABLISHMENT_FAILURE';
export const LOAD_ESTABLISHMENTS_SUCCESS = 'LOAD_ESTABLISHMENTS_SUCCESS';
export const LOAD_ESTABLISHMENTS_FAILURE = 'LOAD_ESTABLISHMENTS_SUCCESS';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';
export const USER_RETRIEVED_SUCCESS = 'USER_RETRIEVED_SUCCESS';
export const USER_RETRIEVED_FAILURE = 'USER_RETRIEVED_FAILURE';
export const ESTABLISHMENT_FORM_SUCCESS = 'ESTABLISHMENT_FORM_SUCCESS';
export const RETRIEVED_ALL_FORMS_SUCCESS = 'RETRIEVED_ALL_FORMS_SUCCESS';
export const ESTABLISHMENTS_RETRIEVED_SUCCESS = 'ESTABLISHMENTS_RETRIEVED_SUCCESS';
export const LOGOUT_ESTABLISHMENT = 'LOGOUT_ESTABLISHMENT';
export const LOGOUT_USER = 'LOGOUT_USER';
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERRORS = 'REMOVE_ERRORS';
export const CREATE_INJURY_SUMMARY_DATA_SUCCESS = 'CREATE_INJURY_SUMMARY_DATA_SUCCESS';
export const LOAD_INJURY_SUMMARY_DATA_SUCCESS = 'LOAD_INJURY_SUMMARY_DATA_SUCCESS';
export const LOAD_ALL_INJURY_SUMMARY_DATA_SUCCESS = 'LOAD_ALL_INJURY_SUMMARY_DATA_SUCCESS';
export const EDIT_INJURY_SUMMARY_DATA_SUCCESS = 'EDIT_INJURY_SUMMARY_DATA_SUCCESS';
export const PASSWORD_FORGOT_SUCCESS = 'PASSWORD_FORGOT_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const REMOVE_ESTABLISHMENT_SUCCESS = 'REMOVE_ESTABLISHMENT_SUCCESS';
export const SUBMISSION_CREATED_SUCCESS = 'SUBMISSION_CREATED_SUCCESS';
export const LOAD_SUBMISSION_DATA_SUCCESS = 'LOAD_SUBMISSION_SUCCESS';
export const FILE_SUBMISSION_SUCCESS = 'FILE_SUBMISSION_SUCCESS';
export const LOAD_STATE_PLAN_STATES_SUCCESS = 'LOAD_STATE_PLAN_STATES_SUCCESS';
export const SET_FRONT_PAGE_FILTER_SUCCESS = 'SET_FRONT_PAGE_FILTER_SUCCESS';
export const CLEAR_FRONT_PAGE_FILTER = 'CLEAR_FRONT_PAGE_FILTER';
export const HELP_DESK_EMAIL_SENT_SUCCESS = 'HELP_DESK_EMAIL_SENT_SUCCESS';
export const LOAD_NAICS_CODES_SUCCESS = 'LOAD_NAICS_CODES_SUCCESS';
export const CLEAR_NAICS_CODES = 'CLEAR_NAICS_CODES';
export const CREATE_ESTABLISHMENT_USER_SUCCESS = 'CREATE_ESTABLISHMENT_USER_SUCCESS';
export const LOAD_ESTABLISHMENT_USERS_SUCCESS = 'LOAD_ESTABLISHMENT_USERS_SUCCESS';
export const REMOVE_ESTABLISHMENT_USERS_SUCCESS = 'REMOVE_ESTABLISHMENT_USERS_SUCCESS';
export const CREATE_ESTABLISHMENT_USER_FAILURE = 'CREATE_ESTABLISHMENT_USER_FAILURE';
export const EDIT_ESTABLISHMENT_USER_SUCCESS = 'EDIT_ESTABLISHMENT_USER_SUCCESS';
export const SAVE_ESTABLISHMENT_USERS_SUCCESS = 'SAVE_ESTABLISHMENT_USERS_SUCCESS';
export const LOAD_ALL_CASE_DATA_SUCCESS = 'LOAD_ALL_CASE_DATA_SUCCESS';
export const LOAD_CASE_DATA_SUCCESS = 'LOAD_CASE_DATA_SUCCESS';
export const CREATE_CASE_DATA_SUCCESS = 'CREATE_CASE_DATA_SUCCESS';
export const CLEAR_CASE_DATA_PAGE_FILTER = 'CLEAR_CASE_DATA_PAGE_FILTER';
export const QUERY_ESTABLISHMENTS_WITH_VALIDATION_SUCCESS = 'QUERY_ESTABLISHMENTS_WITH_VALIDATION_SUCCESS';
export const TRANSFER_ESTABLISHMENTS_SUCCESS = 'TRANSFER_ESTABLISHMENTS_SUCCESS';



/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/